import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DataHelper } from '@app/helpers/data.helper';
import { TranslateService } from '@app/services/translate.service';
import { environment } from '@environments/environment';
import { UiHelper } from '@helpers/ui.helper';

@Component({
  selector: 'bonus-summary-modal',
  templateUrl: '../sharedTemplates/bonus-summary-modal.html',
})
export class BonusSummaryModal {
  isMobileView = false;
  ModalTypes = [
    {
      id: 1,
      title: 'Boost Bonus',
      imageDesktopUrlName: 'wa_boost_desktop',
      imageMobileUrlName: 'wa_boost_mobile',
      headerText: this._TranslateService.instant('boost_bonus_modal_3', { rateAmount: '' }),
      headerDescription: this._TranslateService.instant('boost_bonus_modal_2', { maxBetAmount: '', currency: environment.currencySymbol }),
      btnText: this._TranslateService.instant('boost_bonus_modal_1'),
    },
    {
      id: 2,
      title: 'FreeBet Bonus',
      imageDesktopUrlName: 'wa_freebet_desktop',
      imageMobileUrlName: 'wa_freebet_mobile',
      headerText: this._TranslateService.instant('freebet_text_1', { freebetAmount: '', currency: environment.currencySymbol }),
      headerDescription: this._TranslateService.instant('freebet_text_2', { freebetAmountStake: '', currency: environment.currencySymbol }),
      btnText: this._TranslateService.instant('freebet_text_3'),
    },
  ];
  selectedBonusModal;

  constructor(public _DataHelper: DataHelper, public dialogRef: MatDialogRef<BonusSummaryModal>, private _TranslateService: TranslateService, private _UiHelper: UiHelper) {
    this.selectedBonusModal = this.ModalTypes[0];

    this.setBonusModal();
    this._UiHelper.closeAllMenus();
    this._UiHelper.windowsWidth < 990 ? (this.isMobileView = true) : (this.isMobileView = false);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  setBonusModal() {
    if (this._DataHelper.selectedWallet.IsBoostBonus && this._DataHelper.customerBoostBonusInfo && this._DataHelper.customerBoostBonusInfo.BonusRate) {
      this.selectedBonusModal = this.ModalTypes[0];
      this.selectedBonusModal.headerText = this._TranslateService.instant('boost_bonus_modal_3', { rateAmount: this._DataHelper.customerBoostBonusInfo.BonusRate.toFixed(2) });
      this.selectedBonusModal.headerDescription = this._TranslateService.instant('boost_bonus_modal_2', {
        maxBetAmount: this._DataHelper.customerBoostBonusInfo.MaxAmount,
        currency: environment.currencySymbol,
      });
    } else if (this._DataHelper.selectedWallet.IsFreeBetBonus && this._DataHelper.customerFreeBetBonusInfo && this._DataHelper.customerFreeBetBonusInfo.BonusAmount) {
      this.selectedBonusModal = this.ModalTypes[1];
      this.selectedBonusModal.headerText = this._TranslateService.instant('freebet_text_1', {
        freebetAmount: this._DataHelper.customerFreeBetBonusInfo.BonusAmount,
        currency: environment.currencySymbol,
      });
      this.selectedBonusModal.headerDescription = this._TranslateService.instant('freebet_text_2', {
        freebetAmountStake: this._DataHelper.customerFreeBetBonusInfo.BonusAmount,
        currency: environment.currencySymbol,
      });
    }
  }
}
